import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { LoginResponse } from '../models/loginResponse.model';
import { ChangePasswordPayload, ForgotPayload, LoginPayload, ResetPasswordPayload, VerifyOtpPayload, VerifyOtpResponse } from '../models/auth.model';
import { environment } from '../../environments/environment';
import { CommonResponse } from '../models/common.model';
import { ProfilePayload } from '../models/profilePayload.model';
import { defaultCountryCode } from '../core/constants/defaultNo.const';
import { NotificationResponse } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  profileDetails: BehaviorSubject<LoginResponse | null> =
    new BehaviorSubject<LoginResponse | null>(null);
  FCMtoken: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  defaultCountryCode = defaultCountryCode;
  isOpen$ = this.isOpenSubject.asObservable();

  resetTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  emailSubject: BehaviorSubject<ForgotPayload | null> =
    new BehaviorSubject<ForgotPayload | null>(null);

  constructor(private readonly http: HttpClient) {}

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  loginAdmin(data: LoginPayload): Observable<LoginResponse> {
    return this.http
      .post<{
        data: LoginResponse;
      }>(`${environment.base_url}login`, data)
      .pipe(map(res => res.data));
  }

  forgotPassword(data: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}forgotPassword`,
      data
    );
  }

  verifyOtp(data: VerifyOtpPayload): Observable<VerifyOtpResponse> {
    return this.http
      .post<{
        data: VerifyOtpResponse;
      }>(`${environment.base_url}verifyOtp`, data)
      .pipe(map(res => res.data));
  }

  resetPassword(data: ResetPasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`${environment.base_url}resetPassword`, data)
      .pipe(map(res => res));
  }

  getProfile(): Observable<LoginResponse> {
    return this.http
      .get<{ data: LoginResponse }>(`${environment.base_url}getProfile`)
      .pipe(map(res => res.data));
  }

  updateProfile(data: ProfilePayload): Observable<LoginResponse> {
    return this.http
      .put<{
        data: LoginResponse;
      }>(`${environment.base_url}updateProfile`, data)
      .pipe(map(res => res.data));
  }

  changePassword(data: ChangePasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`${environment.base_url}changePassword`, data)
      .pipe(map(res => res));
  }

  logout(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${environment.base_url}logout`);
  }

  toggleSidebarView(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  getHeaderNotification(query?:string): Observable<NotificationResponse> {
    return this.http
      .get<{ data: NotificationResponse }>(`${environment.base_url}getBellNotification?${query}`)
      .pipe(map(res => res.data));
  }
  
}
